<template>
  <div class="apply-dialog">
    <el-dialog
      :title="conditionDialogTitle"
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      width="420px"
      center>
      <div class="content">
        <div v-html="applyCondition"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="confirm-button" @click="confirm">{{$t('quotes.confirm')}}</el-button>
        <el-button type="cancel-button" @click="cancel">{{$t('quotes.cancel')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    conditionDialogTitle: {
      type: String,
      default: () => ''
    },
    applyCondition: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
    }
  },
  methods: {
    confirm () {
      this.$emit('update:dialogVisible', false)
      this.$emit('confirmCondition')
    },
    cancel () {
      this.$emit('update:dialogVisible', false)
    }
  }
}
</script>
<style lang="scss">
.apply-dialog {
  .el-dialog--center {
    height: 560px !important;
  }
  .el-dialog__body {
    padding-top: 0px;
  }
  .el-dialog__title {
    font-size:16px;
    font-family:PingFangSC-Semibold,PingFang SC;
    font-weight:600;
    color:rgba(12,32,69,1);

  }
  .content {
    height:260px;
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(125,125,125,1);
    line-height:20px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .dialog-footer {
    .el-button{
      display: block;
      margin: 0px auto 20px auto;
      width:250px;
      height:56px;
      border-radius:5px;
      font-size:14px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(25,43,87,1);
      line-height:20px;
    }
    .el-button--confirm-button {
      background:rgba(254,192,0,1) !important;
    }
    .el-button--cancel-button {
      background:white;
      border:1px solid rgba(25,43,86,1) !important;
    }

  }
}
</style>
